import React from "react";
import SysApiLogsList from "../component/SysApiLogList";

const SysApiLogsListContainer = ({ pageId }) => (<SysApiLogsList pageId={ pageId } />)

export default SysApiLogsListContainer;